module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hresh1x-detail-tab2"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRPM4GEC2']['40']) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.numseq))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.codpunsh) + " - " + _vm._s(_vm.data.desc_codpunsh))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.desc_typpun))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.data.dtestart)))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.data.dteend)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('textarea', {
    staticClass: "form-control readonly-field-color",
    attrs: {
      "readonly": "readonly"
    }
  }, [_vm._v(_vm._s(_vm.data.remark))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.flgexempt),
      expression: "data.flgexempt"
    }],
    attrs: {
      "type": "radio",
      "value": "Y",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.data.flgexempt, "Y")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "flgexempt", "Y")
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['80']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.flgexempt),
      expression: "data.flgexempt"
    }],
    attrs: {
      "type": "radio",
      "value": "N",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.data.flgexempt, "N")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "flgexempt", "N")
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['90']))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.codexemp) + " - " + _vm._s(_vm.data.desc_codexemp))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.flgblist),
      expression: "data.flgblist"
    }],
    attrs: {
      "type": "radio",
      "value": "Y",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.data.flgblist, "Y")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "flgblist", "Y")
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['120']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.flgblist),
      expression: "data.flgblist"
    }],
    attrs: {
      "type": "radio",
      "value": "N",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.data.flgblist, "N")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "flgblist", "N")
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['130']))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.coduser))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM4GEC3']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.data.dteupd)))])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56b9a81d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hresh1x/detailTab2.vue
// module id = 3779
// module chunks = 1